import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

import { Logo } from '@/components/brand/Logo';
import { GoldThread } from '@/components/brand/GoldThread';

export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-ink text-bone mt-24 md:mt-32">
      <div className="container py-16 md:py-24">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-y-10 gap-x-8">
          {/* Brand column */}
          <div className="col-span-2 md:col-span-4 space-y-4">
            <Logo variant="light" className="text-2xl" asLink={false} />
            <p className="font-body text-sm text-bone/65 max-w-xs leading-relaxed">
              {t('footer.tagline')}
            </p>
            <GoldThread />
          </div>

          {/* Menu */}
          <div className="col-span-1 md:col-span-2 space-y-4">
            <h3 className="eyebrow text-bone/55">{t('footer.menu_title')}</h3>
            <ul className="space-y-2 font-body text-sm">
              <li><Link to="/"         className="text-bone hover:text-gold">{t('nav.home')}</Link></li>
              <li><Link to="/about"    className="text-bone hover:text-gold">{t('nav.about')}</Link></li>
              <li><Link to="/services" className="text-bone hover:text-gold">{t('nav.services')}</Link></li>
              <li><Link to="/pricing"  className="text-bone hover:text-gold">{t('nav.catalog')}</Link></li>
              <li><Link to="/contact"  className="text-bone hover:text-gold">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="col-span-1 md:col-span-2 space-y-4">
            <h3 className="eyebrow text-bone/55">{t('footer.legal_title')}</h3>
            <ul className="space-y-2 font-body text-sm">
              <li><Link to="/privacy" className="text-bone hover:text-gold">{t('footer.privacy')}</Link></li>
              <li><Link to="/terms"   className="text-bone hover:text-gold">{t('footer.terms')}</Link></li>
              <li><Link to="/refund"  className="text-bone hover:text-gold">{t('footer.refund')}</Link></li>
            </ul>
          </div>

          {/* Visit us */}
          <div className="col-span-2 md:col-span-4 space-y-4">
            <h3 className="eyebrow text-bone/55">{t('footer.visit_title')}</h3>
            <ul className="space-y-3 font-body text-sm leading-relaxed">
              <li className="flex gap-3 items-start">
                <MapPin size={16} className="text-gold mt-0.5 flex-shrink-0" />
                <span className="text-bone/80">{t('contact.address_value')}</span>
              </li>
              <li className="flex gap-3 items-center">
                <Phone size={16} className="text-gold flex-shrink-0" />
                <a href="tel:+97334240115" className="text-bone hover:text-gold">{t('contact.phone_value')}</a>
              </li>
              <li className="flex gap-3 items-center">
                <Mail size={16} className="text-gold flex-shrink-0" />
                <a href="mailto:info@thelaundryco.com" className="text-bone hover:text-gold">{t('contact.email_value')}</a>
              </li>
              <li className="flex gap-3 items-start">
                <Clock size={16} className="text-gold mt-0.5 flex-shrink-0" />
                <span className="text-bone/80">
                  {t('contact.hours_weekdays')}<br />
                  {t('contact.hours_friday')}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright bar */}
        <div className="mt-16 pt-8 border-t border-bone/10">
          <p className="font-body text-xs text-bone/45 leading-relaxed">
            {t('footer.copyright', { year })}
          </p>
        </div>
      </div>
    </footer>
  );
}
